import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  ReferenceField,
  Filter,
  TextInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput
} from 'react-admin';
import { ApiResource } from '../../lib/api';

const UsersFilter: React.FC = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput source='id'/>
      <TextInput source='uuid'/>
      <TextInput source='username'/>
      <TextInput source='email'/>
      <BooleanInput source='tester'/>
      <BooleanInput source='companyAdmin'/>
      <BooleanInput source='superAdmin'/>
      <TextInput source='position'/>
      <ReferenceInput
        source='companyId'
        reference={ApiResource.Companies}
        filterToQuery={(searchText: string) => ({
          name: searchText
        })}
      >
        <AutocompleteInput optionText='name'/>
      </ReferenceInput>
      <BooleanInput source='dsp'/>
      <BooleanInput source='multi'/>
      <TextInput source='firstname'/>
      <TextInput source='middlename'/>
      <TextInput source='lastname'/>
      <TextInput source='phone'/>
      <TextInput source='description'/>
      <TextInput source='personnelNumber'/>
    </Filter>
  );
};

const UsersList: React.FC = (props: any) => {
  return (
    <List
      filters={<UsersFilter/>}
      {...props}
    >
      <Datagrid
        rowClick='edit'
      >
        <TextField source='id'/>
        <TextField source='uuid'/>
        <TextField source='username'/>
        <EmailField source='email'/>
        <BooleanField source='tester'/>
        <BooleanField source='companyAdmin'/>
        <BooleanField source='superAdmin'/>
        <ReferenceField
          source='companyId'
          reference={ApiResource.Companies}>
          <TextField source='name'/>
        </ReferenceField>
        <BooleanField source='multi'/>
        <TextField source='firstname'/>
        <TextField source='middlename'/>
        <TextField source='lastname'/>
        <TextField source='phone'/>
        <TextField source='personnelNumber'/>
      </Datagrid>
    </List>
  );
};

export default UsersList;